import { render, staticRenderFns } from "./CostBearersAttendees.vue?vue&type=template&id=5c869779"
import script from "./CostBearersAttendees.vue?vue&type=script&lang=ts"
export * from "./CostBearersAttendees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports